import { COLORS } from '@laerdal/life-react-components';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import posthog from 'posthog-js';

const FullPageContainer = styled.div`
  display:flex;
`;
const TopSectionContainer = styled.div<{ $setPadding?: boolean }>`
  margin: ${props => props.$setPadding !== false ? '32px auto 0 auto;' : '0'};
  
  max-width: 1000px;
  padding: ${props => props.$setPadding !== false ? '0 16px' : '0'};
  flex-grow: 1;
  display:flex;
`;
const Breadcrumb = styled.div`
  padding:12px 0;
`;

const CrumbLink = styled.a`
  &:link, &:visited, &:hover, &:active {
    color: ${COLORS.primary_600};
    text-decoration: none; 
  }

  color: ${COLORS.primary_600};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

const CrumbText = styled.span`
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

const Devider = styled.span`
  padding: 0 10px;
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

interface Props {
  breadcrumb: Crumb[]
  setPadding?: boolean;
}
interface Crumb {
  text: string;
  link?: string;
}

const BreadcrumbTopSection = (props: Props) => {
  const navigate = useNavigate()

  return (
    <FullPageContainer>
      <TopSectionContainer $setPadding={props.setPadding}>
        <Breadcrumb>
          {props.breadcrumb.map((item, index) =>
            <>
              {!!item.link &&
                <CrumbLink
                  onClick={(e) => {
                    e.preventDefault();
                    posthog.capture('SUPP-BreadcrumbClick', {
                      currentUrl: window.location.href,
                      clickedLink: item.link,
                      step: 1
                    });
                    navigate(item.link!);
                  }}
                  href={item.link!}
                >
                  {item.text}
                </CrumbLink>
              }
              {!item.link &&
                <CrumbText>
                  {item.text}
                </CrumbText>
              }

              {(props.breadcrumb.length != index + 1) &&
                <Devider>/</Devider>
              }
            </>
          )
          }
        </Breadcrumb>
      </TopSectionContainer>
    </FullPageContainer>
  );
}

export default BreadcrumbTopSection;